/**
 * Tarjetas secundarias de /disenador/herramientas (Fase 1B + administración técnica de datos).
 * Robot SAT y monitor técnico viven como acordeones plegados en DesignerToolsHub.jsx.
 */

/** Rutas operativas del Visor que no deben listarse como tarjetas individuales en herramientas. */
export const DESIGNER_TOOLS_REMOVED_OPERATIONAL_LABELS = [
  "Estado sincronización SAT",
  "Gestión de datos",
  "Mis CFDI (vista completa)",
  "Descarga de CFDI SAT",
  "CSF y opinión SAT",
  "Visores CFDI (Similar SAT)",
  "Inicio del módulo Visor",
];

/** Ruta existente — respaldo, restauración y mantenimiento unificados (GestionDatos.jsx). */
export const GESTION_DATOS_PATH = "/gestion-datos";

/** Sección — Administración técnica de datos (soporte / diseñador). */
export const DESIGNER_DATA_ADMIN_SECTION = {
  id: "data_admin",
  title: "Administración técnica de datos",
  intro:
    "Respaldo, recuperación y mantenimiento preventivo del sistema. Uso exclusivo del diseñador o soporte autorizado.",
};

/**
 * Tarjetas de administración técnica — enlazan a secciones de /gestion-datos (ruta real).
 * Nota: la pantalla exige modo Despacho + titular/comprador admin para operar; el diseñador accede vía soporte.
 */
export const DESIGNER_DATA_ADMIN_CARDS = [
  {
    path: GESTION_DATOS_PATH,
    hash: "#respaldo",
    label: "Respaldo de datos",
    description: "Generación o consulta de respaldos del sistema según las herramientas disponibles.",
    iconKey: "database",
    testid: "designer-tool-data-backup",
    status: "real",
  },
  {
    path: GESTION_DATOS_PATH,
    hash: "#restauracion",
    label: "Recuperación / restauración de datos",
    description: "Acceso controlado a restauración o recuperación de información respaldada.",
    iconKey: "validate",
    testid: "designer-tool-data-restore",
    status: "real",
  },
  {
    path: GESTION_DATOS_PATH,
    hash: "#mantenimiento",
    label: "Mantenimiento y limpieza de residuos",
    description:
      "Revisión de archivos temporales, residuos, registros huérfanos o mantenimiento técnico.",
    iconKey: "wrench",
    testid: "designer-tool-data-maintenance",
    status: "real",
  },
];

/** Única tarjeta de enlace al módulo operativo Visor SAT (acceso global PD). */
export const DESIGNER_VISOR_MODULE_LINK_CARD = {
  path: "/visor/inicio",
  label: "Ir al módulo Visor SAT",
  description:
    "Abre el módulo operativo Visor SAT para consultar CFDI, descargas, sincronización, CSF/opinión y visores.",
  iconKey: "panel",
  testid: "designer-tool-visor-module-link",
  visorModule: true,
};

/** Tarjetas de enlace operativo — vacío: usar Panel General → Visor SAT (evita duplicar navegación). */
export const DESIGNER_TOOL_CARDS = [];

/** Resuelve destino de navegación para tarjeta con hash opcional. */
export function resolveDesignerToolCardPath(card) {
  if (!card?.path) return "/";
  return card.hash ? `${card.path}${card.hash}` : card.path;
}

/** Accesos al Centro de Licencias BNT (legacy subhub; Fase 1 redirige a /platform). */
export const DESIGNER_PLATFORM_CARDS = [
  {
    path: "/platform",
    label: "Panel BNT",
    description: "Métricas de organizaciones, licencias activas, alertas SAT y altas recientes.",
    iconKey: "panel",
    testid: "designer-platform-dashboard",
    category: "platform_saas",
    status: "real",
  },
  {
    path: "/platform/onboarding",
    label: "Alta comercial rápida",
    description: "Crear organización, licencia y administrador en un solo flujo.",
    iconKey: "users",
    testid: "designer-platform-onboarding",
    category: "platform_saas",
    status: "real",
  },
  {
    path: "/platform/organizations",
    label: "Organizaciones",
    description: "Alta, suspensión y datos de clientes comerciales BNT (≠ catálogo distribuidor clásico).",
    iconKey: "clients",
    testid: "designer-platform-organizations",
    category: "platform_saas",
    status: "real",
  },
  {
    path: "/platform/licenses",
    label: "Licencias plataforma (SaaS)",
    description: "Emisión y módulos contratados por organización en el ciclo de varios espacios BNT.",
    iconKey: "briefcase",
    testid: "designer-platform-licenses",
    category: "platform_saas",
    status: "real",
  },
  {
    path: "/platform/users",
    label: "Usuarios BNT por organización",
    description: "Administradores del Centro de Licencias — no son usuarios del distribuidor clásico.",
    iconKey: "users",
    testid: "designer-platform-users",
    category: "platform_saas",
    status: "real",
  },
  {
    path: "/platform/modules",
    label: "Módulos licenciables BNT",
    description: "Visor SAT, Laboral, Trámites, Gestión Despacho y futuros módulos comerciales.",
    iconKey: "settings",
    testid: "designer-platform-modules",
    category: "platform_saas",
    status: "real",
  },
];
